<template>
  <BaseStyle
    :content-style="contentStyle"
  >
    <template v-if="url">
      <video
        class="w-full"
        :controls="!autoFlag"
        playsinline
        :autoplay="autoFlag"
        :muted="autoFlag"
        :poster="thumbnailUrl"
      ><!-- playsinlineはsafariの自動再生のためのオプション -->
        <source
          :src="url"
          type="video/mp4"
        />
      </video>
    </template>
    <template v-else>
      <div class="content-base">
        動画を再生できません
      </div>
    </template>
  </BaseStyle>
</template>

<script lang="ts">
import { toRefs } from '@vueuse/core';
import { defineComponent, onMounted, PropType, ref } from 'vue';

import { useCurrentMedia } from '@/hooks/use_media';
import { Medium } from '@/models/medium';
import { Style } from '@/models/style';

import BaseStyle from './BaseStyle.vue';

export default defineComponent({
  name: 'ContentVideo',
  components: { BaseStyle },
  props: {

    /**
     * スタイル
     */
    contentStyle: {
      type: Object as PropType<Style>,
      default: undefined,
    },

    /**
     * 動画
     */
    medium: {
      type: Object as PropType<Medium>,
      default: undefined,
    },

    /**
     * サムネイル
     */
    thumbnail: {
      type: Object as PropType<Medium>,
      default: undefined,
    },

    /**
     * 自動再生フラグ
     */
    autoFlag: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { medium, thumbnail } = toRefs(props);
    const { getAssetsUrl } = useCurrentMedia();
    const url = ref<string | undefined>(undefined);
    const thumbnailUrl = ref<string | undefined>(undefined);
    onMounted(async () => {
      url.value = medium.value ? `${await getAssetsUrl('videos', medium.value)}` : undefined;
      thumbnailUrl.value = thumbnail.value ? `${await getAssetsUrl('images', thumbnail.value)}` : undefined;
    });
    return {
      url,
      thumbnailUrl,
    };
  },
});
</script>
